if (!customElements.get('ncf-announcement-ticker')) {
  customElements.define(
    'ncf-announcement-ticker',
    class NcfAnnouncementTicker extends HTMLElement {
      connectedCallback() {
        this.pauseButton = this.querySelector('[data-ticker-pause]');
        this.onToggle = this.toggle.bind(this);
        if (this.pauseButton) {
          this.pauseButton.addEventListener('click', this.onToggle);
        }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('is-paused');
          this.setLabel(true);
        }
      }

      disconnectedCallback() {
        if (this.pauseButton) {
          this.pauseButton.removeEventListener('click', this.onToggle);
        }
      }

      toggle() {
        const paused = this.classList.toggle('is-paused');
        this.setLabel(paused);
      }

      setLabel(paused) {
        if (!this.pauseButton) return;
        const next = paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        this.pauseButton.setAttribute('aria-label', next);
        const hidden = this.pauseButton.querySelector('.visually-hidden');
        if (hidden) hidden.textContent = next;
        const icon = this.pauseButton.querySelector('svg path');
        if (icon) {
          icon.setAttribute(
            'd',
            paused ? 'M3 1.5 12 7 3 12.5z' : 'M2 1h3.2v12H2zM8.8 1H12v12H8.8z'
          );
        }
      }
    }
  );
}
